module.exports = __webpack_public_path__ + "img/42-config-produtividade-params.fe39a683.png";